export default __webpack_public_path__ + "static/media/icons8-twitter.a6a18d76.svg";